<template>
    <section>
        <o-timepicker inline />
    </section>
</template>
